import React, { Component } from 'react';
import '../../../Common/Common.css';
import './ServiceSectionBottom.css';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import iconCalc from '../../../../assets/img/calculator.png';
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import {BASE_URL} from "../../../../configuration";

class ServiceSectionBottom extends Component {

    constructor(props) {
        super(props);
        this.state = {
            quotationPcb: {
                orderType: 1,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails : 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe : 1,
                    castellatedHoles : 0,
                    silkColor : 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            },
            quotationStencil : {
                orderType: 3,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails : 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe : 1,
                    castellatedHoles : 0,
                    silkColor : 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            }
        };
this.toPcbQuotationHomePageService = this.toPcbQuotationHomePageService.bind(this);
this.toStencilQuotationHomePageService = this.toStencilQuotationHomePageService.bind(this);
    }
    toPcbQuotationHomePageService = (event) => {

        localStorage.setItem("type", 1);
        localStorage.setItem("type1q", JSON.stringify(this.state.quotationPcb));


    };

    toStencilQuotationHomePageService = (event) => {

        localStorage.setItem("type", 3);
        localStorage.setItem("type3q", JSON.stringify(this.state.quotationStencil));


    };

    render(){
        return(
            <div className="home-pg-section-3">
                <div className="homepage-heading ">
                    <FormattedMessage id="app.home-content.pcb-btn-section-heading"
                                      defaultMessage="KITCUT PCB is the lowest level in the world, first, try an estimation!"
                                      description=""/>
                </div>

                <br/>
                <div className="col-md-12 heading-padding">
                    <div className="col-md-6">
                        <Link to='quotation/pcb'>
                        <a onClick={this.toPcbQuotationHomePageService}>

                        <div className="col-md-12 section-btn1 text-center cursor-point-change">
                            <div className="col-md-3 cursor-point-change">
                                <img className="cal-icon-yll-1 cursor-point-change" src={iconCalc}/>

                            </div>
                            <div className="col-md-6 cursor-point-change" >
                                <label className="button-caption-1 cursor-point-change">
                                    <FormattedMessage id="app.home-content.pcb-btn-section.btn1-caption"
                                                      defaultMessage="Substrate Manufacturing Estimate"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="col-md-3">
                                <i className="glyphicon glyphicon-circle-arrow-right btn1-arrow pull-right"></i>

                            </div>

                        </div>
                        </a>
                        </Link>

                    </div>
                    <div className="col-md-6">
                        <Link to='quotation/stencil'>
                        <a onClick={this.toStencilQuotationHomePageService}>
                        <div className="col-md-12 section-btn2">
                            <img className="cal-icon-yll-2" src={iconCalc}/>&nbsp;
                            <FormattedMessage id="app.home-content.pcb-btn-section.btn2-caption"
                                              defaultMessage="Metal Mask Production Estimate"
                                              description=""/>&nbsp;
                            <i className="glyphicon glyphicon-circle-arrow-right btn2-arrow pull-right"></i>
                        </div>

                        </a>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

}

export default ServiceSectionBottom;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/ServiceSectionBottom/ServiceSectionBottom.js